/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceSpineTokens } from './SurfaceSpineTokens';
import {
    SurfaceSpineTokensFromJSON,
    SurfaceSpineTokensFromJSONTyped,
    SurfaceSpineTokensToJSON,
    SurfaceSpineTokensToJSONTyped,
} from './SurfaceSpineTokens';
import type { SurfaceThemePreset } from './SurfaceThemePreset';
import {
    SurfaceThemePresetFromJSON,
    SurfaceThemePresetFromJSONTyped,
    SurfaceThemePresetToJSON,
    SurfaceThemePresetToJSONTyped,
} from './SurfaceThemePreset';

/**
 * Theme configuration with preset, extended tokens, and design controls
 * @export
 * @interface SurfaceThemeConfig
 */
export interface SurfaceThemeConfig {
    /**
     * 
     * @type {SurfaceThemePreset}
     * @memberof SurfaceThemeConfig
     */
    preset?: SurfaceThemePreset;
    /**
     * Glow/shadow color for cards (rgba)
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    surfaceGlow?: string;
    /**
     * Default subtle border color
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    borderSubtle?: string;
    /**
     * Default gradient start color
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    gradientStart?: string;
    /**
     * Default gradient end color
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    gradientEnd?: string;
    /**
     * Navigation bar background color
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    navBackground?: string;
    /**
     * Hero gradient overlay color
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    heroOverlay?: string;
    /**
     * Global corner radius
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    borderRadius?: SurfaceThemeConfigBorderRadiusEnum;
    /**
     * Card surface treatment
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    cardStyle?: SurfaceThemeConfigCardStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    shadowIntensity?: SurfaceThemeConfigShadowIntensityEnum;
    /**
     * Section/block gap sizing
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    spacing?: SurfaceThemeConfigSpacingEnum;
    /**
     * Global animation intensity
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    animationLevel?: SurfaceThemeConfigAnimationLevelEnum;
    /**
     * Enable parallax scroll on hero section
     * @type {boolean}
     * @memberof SurfaceThemeConfig
     */
    heroParallax?: boolean;
    /**
     * Navigation sticks on scroll
     * @type {boolean}
     * @memberof SurfaceThemeConfig
     */
    stickyNav?: boolean;
    /**
     * Heading font weight (400-900)
     * @type {number}
     * @memberof SurfaceThemeConfig
     */
    headingWeight?: number;
    /**
     * Heading line height (0.8-1.5)
     * @type {number}
     * @memberof SurfaceThemeConfig
     */
    headingLineHeight?: number;
    /**
     * Heading letter spacing (-2 to 5, em units x 100)
     * @type {number}
     * @memberof SurfaceThemeConfig
     */
    headingLetterSpacing?: number;
    /**
     * Base body font size
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    bodySize?: SurfaceThemeConfigBodySizeEnum;
    /**
     * Text transform for headings
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    headingTransform?: SurfaceThemeConfigHeadingTransformEnum;
    /**
     * Page-level background image URL (full-bleed behind all content)
     * @type {string}
     * @memberof SurfaceThemeConfig
     */
    backgroundImageUrl?: string;
    /**
     * 
     * @type {SurfaceSpineTokens}
     * @memberof SurfaceThemeConfig
     */
    spineTokens?: SurfaceSpineTokens;
}


/**
 * @export
 */
export const SurfaceThemeConfigBorderRadiusEnum = {
    none: 'none',
    sm: 'sm',
    md: 'md',
    lg: 'lg',
    pill: 'pill'
} as const;
export type SurfaceThemeConfigBorderRadiusEnum = typeof SurfaceThemeConfigBorderRadiusEnum[keyof typeof SurfaceThemeConfigBorderRadiusEnum];

/**
 * @export
 */
export const SurfaceThemeConfigCardStyleEnum = {
    flat: 'flat',
    elevated: 'elevated',
    glass: 'glass',
    bordered: 'bordered'
} as const;
export type SurfaceThemeConfigCardStyleEnum = typeof SurfaceThemeConfigCardStyleEnum[keyof typeof SurfaceThemeConfigCardStyleEnum];

/**
 * @export
 */
export const SurfaceThemeConfigShadowIntensityEnum = {
    none: 'none',
    subtle: 'subtle',
    medium: 'medium',
    dramatic: 'dramatic'
} as const;
export type SurfaceThemeConfigShadowIntensityEnum = typeof SurfaceThemeConfigShadowIntensityEnum[keyof typeof SurfaceThemeConfigShadowIntensityEnum];

/**
 * @export
 */
export const SurfaceThemeConfigSpacingEnum = {
    compact: 'compact',
    comfortable: 'comfortable',
    generous: 'generous'
} as const;
export type SurfaceThemeConfigSpacingEnum = typeof SurfaceThemeConfigSpacingEnum[keyof typeof SurfaceThemeConfigSpacingEnum];

/**
 * @export
 */
export const SurfaceThemeConfigAnimationLevelEnum = {
    none: 'none',
    subtle: 'subtle',
    full: 'full'
} as const;
export type SurfaceThemeConfigAnimationLevelEnum = typeof SurfaceThemeConfigAnimationLevelEnum[keyof typeof SurfaceThemeConfigAnimationLevelEnum];

/**
 * @export
 */
export const SurfaceThemeConfigBodySizeEnum = {
    sm: 'sm',
    md: 'md',
    lg: 'lg'
} as const;
export type SurfaceThemeConfigBodySizeEnum = typeof SurfaceThemeConfigBodySizeEnum[keyof typeof SurfaceThemeConfigBodySizeEnum];

/**
 * @export
 */
export const SurfaceThemeConfigHeadingTransformEnum = {
    none: 'none',
    uppercase: 'uppercase',
    capitalize: 'capitalize'
} as const;
export type SurfaceThemeConfigHeadingTransformEnum = typeof SurfaceThemeConfigHeadingTransformEnum[keyof typeof SurfaceThemeConfigHeadingTransformEnum];


/**
 * Check if a given object implements the SurfaceThemeConfig interface.
 */
export function instanceOfSurfaceThemeConfig(value: object): value is SurfaceThemeConfig {
    return true;
}

export function SurfaceThemeConfigFromJSON(json: any): SurfaceThemeConfig {
    return SurfaceThemeConfigFromJSONTyped(json, false);
}

export function SurfaceThemeConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceThemeConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'preset': json['preset'] == null ? undefined : SurfaceThemePresetFromJSON(json['preset']),
        'surfaceGlow': json['surfaceGlow'] == null ? undefined : json['surfaceGlow'],
        'borderSubtle': json['borderSubtle'] == null ? undefined : json['borderSubtle'],
        'gradientStart': json['gradientStart'] == null ? undefined : json['gradientStart'],
        'gradientEnd': json['gradientEnd'] == null ? undefined : json['gradientEnd'],
        'navBackground': json['navBackground'] == null ? undefined : json['navBackground'],
        'heroOverlay': json['heroOverlay'] == null ? undefined : json['heroOverlay'],
        'borderRadius': json['borderRadius'] == null ? undefined : json['borderRadius'],
        'cardStyle': json['cardStyle'] == null ? undefined : json['cardStyle'],
        'shadowIntensity': json['shadowIntensity'] == null ? undefined : json['shadowIntensity'],
        'spacing': json['spacing'] == null ? undefined : json['spacing'],
        'animationLevel': json['animationLevel'] == null ? undefined : json['animationLevel'],
        'heroParallax': json['heroParallax'] == null ? undefined : json['heroParallax'],
        'stickyNav': json['stickyNav'] == null ? undefined : json['stickyNav'],
        'headingWeight': json['headingWeight'] == null ? undefined : json['headingWeight'],
        'headingLineHeight': json['headingLineHeight'] == null ? undefined : json['headingLineHeight'],
        'headingLetterSpacing': json['headingLetterSpacing'] == null ? undefined : json['headingLetterSpacing'],
        'bodySize': json['bodySize'] == null ? undefined : json['bodySize'],
        'headingTransform': json['headingTransform'] == null ? undefined : json['headingTransform'],
        'backgroundImageUrl': json['backgroundImageUrl'] == null ? undefined : json['backgroundImageUrl'],
        'spineTokens': json['spineTokens'] == null ? undefined : SurfaceSpineTokensFromJSON(json['spineTokens']),
    };
}

export function SurfaceThemeConfigToJSON(json: any): SurfaceThemeConfig {
    return SurfaceThemeConfigToJSONTyped(json, false);
}

export function SurfaceThemeConfigToJSONTyped(value?: SurfaceThemeConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'preset': SurfaceThemePresetToJSON(value['preset']),
        'surfaceGlow': value['surfaceGlow'],
        'borderSubtle': value['borderSubtle'],
        'gradientStart': value['gradientStart'],
        'gradientEnd': value['gradientEnd'],
        'navBackground': value['navBackground'],
        'heroOverlay': value['heroOverlay'],
        'borderRadius': value['borderRadius'],
        'cardStyle': value['cardStyle'],
        'shadowIntensity': value['shadowIntensity'],
        'spacing': value['spacing'],
        'animationLevel': value['animationLevel'],
        'heroParallax': value['heroParallax'],
        'stickyNav': value['stickyNav'],
        'headingWeight': value['headingWeight'],
        'headingLineHeight': value['headingLineHeight'],
        'headingLetterSpacing': value['headingLetterSpacing'],
        'bodySize': value['bodySize'],
        'headingTransform': value['headingTransform'],
        'backgroundImageUrl': value['backgroundImageUrl'],
        'spineTokens': SurfaceSpineTokensToJSON(value['spineTokens']),
    };
}

